<i18n>
{
  "en": {},
  "zh-Hans": {},
  "zh-Hant": {}
}
</i18n>
<template>
  <div></div>
</template>
<script>
export default {
  name: 'index',
  data () {
    return {
    }
  },
  computed: {
  },
  beforeMount () {
  },
  mounted () {
    this.$router.push({ name: 'sign-in' })
  },
  destroyed () {
  },
  methods: {
  },
  components: {
  }
}
</script>
<style scoped>
</style>
